import { useCallback, useEffect } from 'react'
import { useSelector } from '@/libs/state'
import { listTimeOffRequests } from '../application/list-time-off-requests'
import { teamTimeOffRequests$, timeOffListVersion$ } from '../store'
import { timeoff, notify } from '../wiring'
import type { ApprovalStage, TimeOffType } from '../domain/timeoff'

const STAGES: ApprovalStage[] = ['pending_dept', 'pending_hr', 'approved', 'rejected']
const TYPES: TimeOffType[] = ['vacation', 'sick_leave', 'unpaid_leave', 'parental_leave', 'other']

const useTeamTimeOffRequests = (
	q: string | null,
	memberIds: string[] | null,
	excludeMemberId: string | null,
	approvalStage: string | null,
	type: string | null,
) => {
	const requests = useSelector(teamTimeOffRequests$)
	const version = useSelector(timeOffListVersion$)

	const validStage = STAGES.find(s => s === approvalStage) ?? null
	const validType = TYPES.find(t => t === type) ?? null

	const reload = useCallback(async () => {
		const result = await listTimeOffRequests(
			timeoff,
			{ q, memberId: null, memberIds, approvalStage: validStage, type: validType, start: null, end: null },
			notify,
		)
		const filtered = excludeMemberId ? result.filter(r => r.memberId !== excludeMemberId) : result
		teamTimeOffRequests$.set(filtered)
	}, [q, memberIds, excludeMemberId, validStage, validType])

	useEffect(() => {
		reload()
	}, [reload, version])

	return { requests }
}

export { useTeamTimeOffRequests }
